// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Nav$Web from "./Nav.res.js";
import * as LumiReact from "lumi-rescript/lib/es6/src/LumiReact.res.js";
import * as Common$LumiI18n from "lumi-i18n/lib/es6/src/Common.res.js";
import * as Locale$LumiI18n from "lumi-i18n/lib/es6/src/Locale.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Localization$LumiI18n from "lumi-i18n/lib/es6/src/Localization.res.js";

let Nav = Nav$Web.Make({
  translate: Common$LumiI18n.Provider.translate
});

function ChangeLanguage(props) {
  let locale = Locale$LumiI18n.useContext();
  let setLocale = Localization$LumiI18n.SetLocale.useContext();
  let locales = Localization$LumiI18n.Locales.useContext();
  return JsxRuntime.jsx(Nav.DropDown.make, {
    title: "ChangeLanguage",
    icon: "globe",
    isRight: true,
    children: locales.map(newLocale => JsxRuntime.jsx("a", {
      children: Locale$LumiI18n.name(newLocale),
      className: LumiReact.classList([
        [
          "navbar-item",
          true
        ],
        [
          "is-active",
          newLocale === locale
        ]
      ]),
      onClick: param => setLocale(newLocale)
    }, Locale$LumiI18n.toString(newLocale)))
  });
}

let make = ChangeLanguage;

export {
  Nav,
  make,
}
/* Nav Not a pure module */
